import { useMemo } from 'react';

import { useAppState } from '../AppStateProvider';
import { useUserQuery } from '../features/user/useUserQuery';
import DataExtractionService from '../services/dataExtraction/DataExtractionService';

import { isInternalDomain } from './useIsInternalDomain';

export const useFilterCollectedDomains = () => {
  const { collectedDomains } = useAppState();
  const collectedMeetingDomains = collectedDomains || [];
  const userQuery = useUserQuery();
  const userDomain = DataExtractionService.meeting.extractDomainFromEmail(userQuery.data?.email || '');

  const filteredDomains = useMemo(() => {
    return isInternalDomain(collectedMeetingDomains, userDomain)
      ? collectedMeetingDomains
      : collectedMeetingDomains.filter((domain) => domain !== userDomain);
  }, [collectedMeetingDomains, userDomain]);

  return filteredDomains;
};
